import React, { Children, Component } from "react"
import Loading from "../../components/Loading/Loading"
import TabScreen from "../../components/TabScreen"
import { getUserFlashcardsCached } from "../../services/flashcards/flashcards-rest-interface"
import FlashcardsModal from "../Flashcards/FlashcardsModal"
import VocabFlashcards from "./VocabFlashcards"
import VocabPresentation from "./VocabPresentation"
import { ITeacherFlashcard } from "./types"
import { GenericFlashcards } from "./GenericFlashcards"
import "./index.css"

interface Props {

}

interface State {
    flashcards: ITeacherFlashcard[]
    modalVisible: boolean
    selectedFlashcard?: ITeacherFlashcard
}

export class TeacherFlashcards extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            flashcards: [],
            modalVisible: false,
        }
    }

    async componentDidMount() {
        let flashcards = await getUserFlashcardsCached()
        this.setState({flashcards})
    }

    handleModalClose = () => {
        this.setState({modalVisible: false, selectedFlashcard: undefined})
    }

    onStartPresentation = (flashcard: ITeacherFlashcard) => {
        this.setState({modalVisible: true, selectedFlashcard: flashcard})
    }

    render() {
        let {flashcards, modalVisible, selectedFlashcard} = this.state

        if (flashcards.length === 0) {
            return <Loading/>
        }

        let screenTitle = "Teacher Flashcards"
        let screens = [
            {name: "English", screen: <TeacherFlashcardsScene category="English" flashcards={flashcards} />},
            {name: "Math",    screen: <TeacherFlashcardsScene category="Math"    flashcards={flashcards} />},
            {name: "Science", displayName: "ACT Science", screen: <TeacherFlashcardsScene category="Science" flashcards={flashcards} />},
            {name: "SATVocab", displayName: "SAT Vocab", screen: <TeacherFlashcardsScene category="SATVocab" flashcards={flashcards} onStartPresentation={this.onStartPresentation}/>},
        ]

        return (
            <TabScreen title={screenTitle} screens={screens}>
                <FlashcardsModal show={modalVisible} onClose={this.handleModalClose} dismissible={true}>
                    { selectedFlashcard && <VocabPresentation flashcard={selectedFlashcard} onClose={this.handleModalClose}/> }
                </FlashcardsModal> 
            </TabScreen>
        )
    }
}

//--- Helpers ---
interface ITeacherFlashcardsProps {
    category: "English" | "Math" | "Science" | "SATVocab" // English | Math | Science | SATVocab, etc.
    flashcards: ITeacherFlashcard[],
    onStartPresentation?: (flashcard: ITeacherFlashcard) => void
}

function TeacherFlashcardsScene(props: ITeacherFlashcardsProps){
    let {category, flashcards, onStartPresentation} = props
    let selectedFlashcards = flashcards.filter(f => f.category === category)
    let isVocab = category === "SATVocab"

    return (
        <div>
            { isVocab ?
                <VocabFlashcards flashcards={selectedFlashcards} category={category} onStartPresentation={onStartPresentation}/>
                :
                <GenericFlashcards flashcards={selectedFlashcards} category={category}/>
            }
        </div>
    )
}
